module.exports = __webpack_public_path__ + "img/zfr2.7daf9767.jpg";